import { CodeLogin } from '~/components/pages/login/CodeLogin'
import { CDNImage } from '~/components/business/CDNImage'
import { SEOHead } from '~/components/business/SEOHead'
import { useRouter } from 'next/router'
import { GetServerSideProps } from 'next'
import { GlobalRequest } from '~/components/global-request'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import { PwdLogin } from '~/components/pages/login/PwdLogin'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'
import { ResetPwdModal } from '~/components/pages/login/ResetPwdModal'
import { useAuth } from '~/hooks/useAuth'
import { QRLogin } from '~/components/pages/login/QRLogin'

type LoginType = 'pwd' | 'code' | 'qr'
interface LoginTypes {
  type: LoginType
  label: string
}

const loginTypes: LoginTypes[] = [
  { type: 'code', label: '短信登录' },
  { type: 'qr', label: '扫码登录' },
  { type: 'pwd', label: '账号登录' },
]

const Register = observer(() => {
  const router = useRouter()
  const backUrl = router.query.backto as string
  const [loginType, setLoginType] = useState<LoginType>('code')
  const { store } = useStores()
  const resetPwdVisible = !!store.modal?.resetPwd
  const { isLogin } = useAuth()

  useEffect(() => {
    if (isLogin) {
      router.push('/')
    }
  }, [])

  return (
    <>
      <SEOHead title="登录/注册" />
      <div className="flex items-center justify-start h-screen min-w-[1424px] overflow-y-hidden">
        <div className="w-1/2">
          <CDNImage src="/images/login/bg.jpg"></CDNImage>
        </div>
        <div className="w-1/2">
          <div className="w-[408px] mx-auto">
            <div className="flex items-center gap-6 text-neutral-400 text-lg">
              {loginTypes.map(item => {
                return (
                  <div
                    key={item.type}
                    className={classNames('cursor-pointer mb-8 font-semibold', {
                      'text-neutral-800': item.type === loginType,
                    })}
                    onClick={() => {
                      setLoginType(item.type)
                    }}
                  >
                    {item.label}
                  </div>
                )
              })}
            </div>

            {loginType === 'code' && (
              <div className="pb-[18px]">
                <CodeLogin backUrl={backUrl || '/ai'} />
              </div>
            )}
            {loginType === 'pwd' && (
              <div className="pb-[18px]">
                <PwdLogin backUrl={backUrl || '/ai'} />
              </div>
            )}
            {loginType === 'qr' && <QRLogin backUrl={backUrl || '/ai'} />}
          </div>
        </div>
      </div>

      {resetPwdVisible && <ResetPwdModal />}
    </>
  )
})

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState } = await GlobalRequest(context)
  return {
    props: {
      initialState,
    },
  }
}

export default Register
